module.exports = __webpack_public_path__ + "static/media/IIT-removebg-preview.0b139abe.png";